import { ExaktValues } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/ExaktValues';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function BerechnungsartExakt() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.options.exakt',
        )}
      </span>
      <ExaktValues />
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenMonat.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        <span>
          {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger
            .unbezahlteUeberstundenMonat ?? '00:00'}
        </span>
        <span>
          {` ${t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenMonat.zusammenfassungSuffix',
          )}`}
        </span>
      </span>
    </>
  );
}
